var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeep2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_2",
    "data-name": "katman 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 886.85 872.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: #beceeb;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-7 {\n        fill: #8093ca;\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-13);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 543.39,
    y1: 722.86,
    x2: 502.25,
    y2: 803.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#232451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a307b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 465.16,
    y1: 755.05,
    x2: 506.14,
    y2: 755.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2908f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6b2b2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 408.45,
    y1: 646.62,
    x2: 582.6,
    y2: 402.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a3780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#272f6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#21224b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201d3f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 519.51,
    y1: 804.66,
    x2: 376.9,
    y2: 991.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 448.14,
    y1: 845.05,
    x2: 558.34,
    y2: 845.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40509e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4857a3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 435.52,
    y1: 792.87,
    x2: 473.99,
    y2: 792.87,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 345.68,
    y1: 768.25,
    x2: 355.28,
    y2: 441.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 545.26,
    y1: 276.99,
    x2: 323.24,
    y2: 646.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee7065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2908f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 749.23,
    y1: 28.61,
    x2: 677.22,
    y2: 214.62,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 491.17,
    y1: 188.67,
    x2: 189.49,
    y2: 408.07,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 521.5,
    y1: 72.66,
    x2: 393.5,
    y2: 264.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 447.9,
    y1: 129.18,
    x2: 146.23,
    y2: 348.59,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 231.53,
    y1: 265.69,
    x2: 494.82,
    y2: 250.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9615a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 734.49,
    y1: 107,
    x2: 632.49,
    y2: 177,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 833.66,
    y1: -61.29,
    x2: 591.66,
    y2: 52.71,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 195.47,
    y1: 318.84,
    x2: 663.47,
    y2: -29.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 745.86,
    y1: -1065.37,
    x2: 835.11,
    y2: -1156.94,
    gradientTransform: "translate(-61.48 1422.5) rotate(-14.47)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 10380.41,
    y1: 984.34,
    x2: 10205.9,
    y2: 1032.16,
    gradientTransform: "translate(10825.74 -126.46) rotate(-177.17) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 912.05,
    y1: 458.08,
    x2: 732.05,
    y2: 318.08,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_1",
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 345.22,
    y: 563.83,
    width: 23.3,
    height: 252.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M254.81,820.71h204.11v-10.84c0-2.39-1.94-4.33-4.33-4.33h-195.11c-2.58,0-4.67,2.09-4.67,4.67v10.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 216.22,
    y: 503.82,
    width: 272.73,
    height: 77.35,
    rx: 26.63,
    ry: 26.63
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M486.67,771.2s66.54,47.97,54.99,80.19c0,0-72.81-31.41-81.61-56.16-8.8-24.75,1.49-35.67,1.49-35.67l25.13,11.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M476.67,731l-10.88,31.46c-1.64,4.75,0,10.15,4.25,12.84,2.13,1.34,5.03,2.59,9,3.49,5.61,1.27,11.39-1.32,14.09-6.39l13.02-24.51-29.47-16.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M370.78,447.87s136.68,23.69,195.31,77.85c58.63,54.16-53.82,226.93-53.82,226.93,0,0-18.42-.11-40.75-19.25,0,0,66.67-129.94,9.21-167.83-64.6-42.6-139.04-52.2-139.04-52.2l27.76-61.33,1.32-4.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M530.09,833.57c-14.64-6.78-56.07-35.78-63.06-37.06-6.98-1.28-19.1,6.93-19.1,6.93,0,0-2.95,5.3,.2,14.54,9.73,11.77,31.32,34.2,60.35,42.56,21.35,6.15,36.29,.42,45.59-6.29-5.12-7.79-14.25-16.17-23.99-20.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M508.49,860.55c-29.03-8.36-50.63-30.79-60.35-42.56,2.13,6.25,7.04,14.29,17.54,23.73,26.03,23.39,75.74,31.83,86.33,30.2,8.48-1.3,7.68-9.13,2.08-17.66-9.3,6.71-24.24,12.44-45.59,6.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M435.52,782.97c.16,4.03,8.41,17.86,13.22,25.62,2.29,3.69,6.3,5.94,10.64,5.95,2.75,0,5.92-.23,8.79-1.06,4.31-1.24,6.74-5.83,5.47-10.14l-9.41-32.14-28.72,11.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M239.21,406.84s-30.35,81.17,0,105.85c30.35,24.68,102.77,52.47,118.94,101.64,16.18,49.16,43.63,144.71,80.36,178.55,0,0,25.81-2.5,35.47-12.78,0,0-20.92-142.64-34.72-179.23-11.95-31.69-29.56-77.44-63.3-103.01-9.66-7.32-7.98-18.91-3.5-30.17l8.16-20.51-141.42-40.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M555.79,343.22c-50.9,3.07-35.04-78.24-34.12-81.48l-77.25,54.56s4.09,43.48,68.31,66.29c16.25,5.77,31.1,6.03,44.23,3.2-5.6-16.33-4.46-30.98-1.18-42.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M654.2,318.75c-18.97-13.19-40.45,0-40.45,0-25.36,16.58-44.12,23.64-57.96,24.47-3.28,11.6-4.42,26.25,1.18,42.58,28.41-6.11,48.73-26.67,57.57-37.22,3.18-3.8,8.81-4.46,12.7-1.39,3.95,3.12,7.78,7.39,7.09,11.88-1.37,8.86,8.91,11.68,9.69,8.47,.78-3.21-3.52-22.27-3.52-22.27,0,0,20.57,20.68,28.6,28.63,8.03,7.95,18.13,0,18.13,0,0,0-14.05-41.97-33.01-55.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M318.47,136.18s74.05-29.65,211.85,84.12c0,0,11.51,23.83-1.05,45.03-12.56,21.21-132.2,124.53-148.64,181.84,0,0-71.28,23.16-144.99-31.76,0,0,6.51-159.48,82.84-279.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M464.85,109.72l-36.45,44.19c-3.62,4.39-4.42,10.49-1.91,15.6,5.06,10.32,17.06,25.35,43.69,23.27,7.92-.62,14.93-5.4,18.39-12.55l25.49-52.69-49.2-17.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M261.14,325.43c-8.6-35.01,78.47-113.05,78.47-113.05l-21.14-76.2s-188.01,125.16-140.1,225.81c6.87,14.43,15.99,24.54,26.57,31.29,15.14-40.75,39.26-59.44,56.2-67.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M261.08,320.33c-.92,0-1.76-.63-2-1.57-8.79-35.79,75.51-111.85,79.1-115.07,.84-.76,2.14-.69,2.91,.16,.76,.85,.69,2.15-.16,2.91-.86,.77-86.05,77.62-77.85,111.03,.27,1.1-.4,2.22-1.51,2.49-.16,.04-.33,.06-.49,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M393.02,322.41s-103.23,40.08-128.43,9.93c-1.71-2.04-2.82-4.37-3.45-6.92-16.94,8.41-41.06,27.1-56.2,67.85,54.29,34.69,147.09-19.3,172.19-35.22,4.13-2.62,9.08-3.54,13.87-2.54,9.68,2.01,26.4,4.96,35.41,3.57,13.19-2.03,32.14,44.5,53.52,30.15,0,0-18.31-80.88-86.91-66.82Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M544.16,44.81c.37,1.42-8.54,98.02-8.54,98.02l-55.05-6.26-5.16-92.81s62.61-22.73,68.75,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M489.75,62.99l-1.11,49.07c-.01,.63,.05,1.24,.21,1.85,.96,3.73,5.19,16.33,17.82,11.21,11.45-4.65,21.98-8.72,29.72-7.25,3.47,.66,5.88,3.84,5.55,7.36-.81,8.78-3.01,28.52-7.53,45.38-.92,3.42-4.32,5.54-7.81,4.92-10.51-1.85-32.58-6.38-49.47-14.18-2.29-1.06-3.83-3.25-3.99-5.77-.82-12.27-3.47-49.54-5.81-59.81-2.2-9.64-14.83-14.18-20.26-15.7-1.78-.5-3.27-1.7-4.14-3.33-3.07-5.78-7.93-19.39,9.06-27.06,3.56-1.6,5.06-5.79,3.35-9.3-3.41-6.98-5.72-17.95,7.24-25.55,13.17-7.73,24.33-1.48,30.58,3.91,2.53,2.18,6.19,2.15,8.8,.07,1.49-1.18,3.5-1.74,6.16-.46,3.58,1.72,7.85-.19,9.19-3.92,2.57-7.17,8.53-15.21,22.35-14.38,24.52,1.48,30.17,27.85,25.54,44.18-4.63,16.33-31.13,13.21-44.96,6.75-10.51-4.91-22.61,2.77-27.8,6.74-1.65,1.26-2.61,3.19-2.66,5.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M467.08,113.66s6.85-28.79-4.06-34.46c-10.91-5.67-25.58-.49-20.06,19.21,6.86,24.52,24.12,15.25,24.12,15.25Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M445.9,401.45c.17,0,.33,.01,.5,.01l216.59-.24c5.35,0,9.69-4.35,9.68-9.7,0-5.36-4.37-9.78-9.71-9.68l-216.59,.24c-5.35,0-9.69,4.35-9.68,9.7,0,5.19,4.09,9.42,9.21,9.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M857.69,204.8h-180.38c-13.31,0-25.42,7.68-31.09,19.71l-83.39,176.82h224.16c8.57,0,16.28-5.24,19.43-13.21l64.66-163.62c3.74-9.45-3.23-19.7-13.4-19.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M730.62,295.46c-3.91,12.14-1.02,23.94,6.45,26.34,7.47,2.4,16.7-5.49,20.6-17.63,3.91-12.14,1.02-23.94-6.45-26.34-7.47-2.4-16.7,5.49-20.6,17.63Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M828.45,865.99c1.2,0,2.42-.23,3.59-.72,4.62-1.92,6.75-7.11,4.76-11.58l-190.88-429.6c-1.99-4.47-7.34-6.53-11.96-4.61-4.62,1.92-6.75,7.11-4.76,11.58l190.88,429.6c1.48,3.33,4.84,5.33,8.37,5.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M613.41,865.99c3.53,0,6.88-2,8.37-5.33l190.88-429.6c1.99-4.47-.15-9.65-4.76-11.58-4.61-1.92-9.97,.14-11.96,4.61l-190.88,429.6c-1.99,4.47,.15,9.65,4.76,11.58,1.17,.49,2.39,.72,3.59,.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M237.58,865.99c1.2,0,2.42-.23,3.59-.72,4.62-1.92,6.75-7.11,4.76-11.58L55.06,424.09c-1.99-4.47-7.33-6.53-11.96-4.61-4.62,1.92-6.75,7.11-4.76,11.58l190.88,429.6c1.48,3.33,4.84,5.33,8.37,5.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M22.55,865.99c3.53,0,6.88-2,8.37-5.33L221.79,431.06c1.99-4.47-.15-9.65-4.76-11.58-4.61-1.92-9.97,.14-11.96,4.61L14.19,853.69c-1.99,4.47,.15,9.65,4.76,11.58,1.17,.49,2.39,.72,3.59,.72Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.16,410.83c-.49-2.82,.18-5.73,1.81-7.95,1.63-2.21,4.06-3.5,6.62-3.5H876.97c3.37,0,6.51,1.92,8.33,5.1,1.82,3.18,2.06,7.18,.65,10.6l-9.41,22.8c-2.15,5.22-6.82,8.56-11.96,8.56H14.55c-4.78,0-8.89-3.79-9.8-9.05L.16,410.83Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeep2);
export default __webpack_public_path__ + "static/media/deep2.b9d01aea02088e53f811a32c107458a9.svg";
export { ForwardRef as ReactComponent };